import { Card, CardContent, Grid, Typography, Box } from "@mui/material";
import Section from "./Section.jsx";
import { ReactComponent as LogoSvg } from "../assets/logo-gold.svg";
import { ReactComponent as LogoRedSvg } from "../assets/logo.svg";
import { ReactComponent as StudySvg } from "../assets/study.svg";
import { ReactComponent as StampSvg } from "../assets/stamp.svg";
import { ReactComponent as KeySvg } from "../assets/key.svg";
import { ReactComponent as ColorCodingSvg } from "../assets/color-coding.svg";

export const companyValues = [
  {
    title: "Експертність",
    description: (
      <Box sx={{ textAlign: "justify" }}>
        <Typography sx={{ color: "#ffd700", fontWeight: "bold" }}>
          Освіта європейського рівня.
        </Typography>{" "}
        Кожен рух - результат професійного навчання. Знання
        <Typography
          sx={{ color: "#ffd700", fontWeight: "bold" }}
          variant="span"
        >
          {" "}
          матеріалознавства та професійної хімії
        </Typography>{" "}
        дозволяють нам обирати індивідуальний підхід для поверхонь Вашого дому.
      </Box>
    ),
    Icon: StudySvg,
  },
  {
    title: "Безпека",
    description: (
      <Box sx={{ textAlign: "justify" }}>
        Кольорове кодування. Система розділення по зонам для{" "}
        <Typography
          sx={{ color: "#ffd700", fontWeight: "bold" }}
          variant="span"
        >
          захисту
        </Typography>{" "}
        від перехресного зараження. {" "}
        <Typography
          sx={{ color: "#ffd700", fontWeight: "bold" }}
          variant="span"
        >
          Дезінфекція
        </Typography>{" "}
        інвентарю.
      </Box>
    ),
    Icon: ColorCodingSvg,
  },
  {
    title: "Відповідальність",
    description: (
      <Box sx={{ textAlign: "justify" }}>
        Турбота про Ваш простір та приватність. Ми знаємо цінність кожної деталі
        Вашого інтер'єру. Дбайливе ставлення до поверхонь та{" "}
        <Typography
          sx={{ color: "#ffd700", fontWeight: "bold" }}
          variant="span"
        >
          абсолютна конфіденційність
        </Typography>{" "}
        Вашого приватного життя - наше непохитне правило. Ваша довіра у надійних
        руках, які працюють із{" "}
        <Typography
          sx={{ color: "#ffd700", fontWeight: "bold" }}
          variant="span"
        >
          глибокою пошаною
        </Typography>{" "}
        до Вашого майна та простору.
      </Box>
    ),
    Icon: StampSvg,
  },
  {
    title: "Баланс",
    description: (
      <Box sx={{ textAlign: "justify" }}>
        Ви - душа Вашого простору. Ваші звички, Ваша приватність та право{" "}
        <Typography
          sx={{ color: "#ffd700", fontWeight: "bold" }}
          variant="span"
        >
          бути собою
        </Typography>{" "}
        це те, що ми цінуємо понад усе. Кожен наш візит сповнений щирої поваги
        до Вашої особистості.{" "}
        <Typography
          sx={{ color: "#ffd700", fontWeight: "bold" }}
          variant="span"
        >
          Ваша довіра
        </Typography>{" "}
        - наше натхнення.
      </Box>
    ),
    Icon: LogoRedSvg,
  },
  {
    title: "Таємниця",
    description: (
      <Box sx={{ textAlign: "justify" }}>
        <Typography
          sx={{ color: "#ffd700", fontWeight: "bold" }}
          variant="span"
        >
          Досконалість має свій таємний післясмак.
        </Typography>{" "}
        Ми не просто звільняємо Ваш простір - ми залишаємо в ньому{" "}
        <Typography
          sx={{ color: "#ffd700", fontWeight: "bold" }}
          variant="span"
        >
          дещо особливе
        </Typography>
        . Це наш{" "}
        <Typography
          sx={{ color: "#ffd700", fontWeight: "bold" }}
          variant="span"
        >
          авторський комплімент
        </Typography>{" "}
        Вашому мудрому вибору.
      </Box>
    ),
    applyExtraStyling: true,
    Icon: KeySvg,
  },
];
export default function CompanyValues() {
  return (
    <Section
      id="companyValues"
      title="Цінності"
      containerStyles={{ pt: 0 }}
      headerStyles={{
        color: "#5f2e20",
        textDecoration: "underline",
        textDecorationColor: "#ffd700",
        ":after": { display: "none" },
      }}
    >
      <Grid
        container
        spacing={3}
        sx={{
          justifyContent: "left",
          alignItems: "top",
          width: "100%",
        }}
        padding={2}
      >
        {companyValues.map((service) => {
          const { Icon } = service;
          return (
            <Grid key={service.title} sx={{ width: "100%" }}>
              <Typography
                variant="h6"
                sx={{ textAlign: "left", color: "#5f2e20" }}
              >
                {service.title}
              </Typography>
              <Card
                sx={{
                  position: "relative",
                  p: 1,
                  borderRadius: "15px",
                  ...(service.applyExtraStyling && {
                    background:
                      "linear-gradient(135deg, #fffaf0 0%, #fff8dc 40%, #fffaf0 100%)",
                    "&::before": {
                      content: '""',
                      position: "absolute",
                      top: "-50%",
                      left: "-50%",
                      width: "200%",
                      height: "200%",
                      background:
                        "linear-gradient(120deg, transparent 30%, rgba(255,215,0,0.25) 50%, transparent 70%)",
                      transform: "rotate(15deg)",
                      animation: "goldShimmer 4s linear infinite",
                      pointerEvents: "none",
                      zIndex: 0,
                    },
                    "@keyframes goldShimmer": {
                      "0%": {
                        transform: "translateX(-60%) rotate(15deg)",
                      },
                      "100%": {
                        transform: "translateX(60%) rotate(15deg)",
                      },
                    },
                  }),
                }}
              >
                <CardContent sx={{ textAlign: "left" }}>
                  {/* Icon floats and affects ONLY first line */}
                  <Box
                    sx={{
                      float: "left",
                      width: 28,
                      height: 28,
                      mx: 1.5,
                      mt: "4px",
                    }}
                  >
                    <Icon
                      style={{
                        width: "25px",
                        height: "25px",
                        display: "block",
                        color: "#ffd700"
                      }}
                    />
                  </Box>

                  {/* Text flows naturally around icon */}
                  <Box
                    component="span"
                    sx={{
                      display: "block",
                      color: "#5f2e20",
                      lineHeight: 1.6,
                      textAlign: "justify",
                    }}
                  >
                    {service.description}
                  </Box>
                </CardContent>
                <LogoSvg
                  style={{
                    position: "absolute",
                    bottom: "6px",
                    right: "6px",
                    width: "20px",
                    height: "20px",
                    opacity: 0.8,
                    pointerEvents: "none",
                  }}
                />
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </Section>
  );
}
